/**
 * @file_purpose  page for showing video portfolio contact form 
 * @author Sucheta Singha
 * @Date_Created 19-09-2024
 * @Date_Modified 19-09-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, useLocation, Link } from 'react-router-dom'
import {
    CForm,
    CInput,
    CInputCheckbox,
    CButton,
    CTextarea,
    CSpinner,
    CSelect
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import helpers from 'src/Utility/Helpers';
import VideoPortBanner from "../../../assets/icons/video_banner.png"
import VideoLogo from "../../../assets/icons/vid_logo.png"

export default function VideoPortfolioContactForm() {
    const history = useHistory();
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    const [loader, setLoader] = useState(0);
    const [nameErrors, setNameErrors] = useState('');
    const [emailErrors, setEmailErrors] = useState('');
    const [phoneErrors, setPhoneErrors] = useState('');
    const [isTextFieldDisable, setIsTextFieldDisable] = useState(false);
    const [countryCode, setcountryCode] = useState([]);
    const [countryCodeErrors, setCountryCodeErrors] = useState('');
    const [state, setState] = useState({
        name: '',
        email: '',
        phone_number: '',
        company_name: '',
        additional_info: '',
        country: '',

        upload: '',
        is_nda: 0,
        is_term_conditions: 0,
        appointment_guest_email: "",
        country_code_id: "1"
    })
    const video_portfolio_email = localStorage.getItem('video_portfolio_email');
    const video_portfolio_name = localStorage.getItem('video_portfolio_name');
    const video_portfolio_phone = localStorage.getItem('video_portfolio_phone');
    const video_portfolio_country_code = localStorage.getItem('video_portfolio_country_code');
    useEffect(() => { window.scrollTo(0, 0) }, [])

    useEffect(() => {
        loadCountrieslist()
    }, [])

    /**
 * @author Sucheta Singha
 * @Date_Created 08-09-2024
 * @Date_Modified 08-09-2024
 * @function async
 * @functionName loadCountrieslist
 * @functionPurpose this function gets the list of country with country code.
 *
 * @functionParam {}
 *
 * @functionSuccess Success status and message.
 *
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */
    async function loadCountrieslist() {
        GeneralService.apiGetCallRequestWithoutToken(RouteURL.getCountrieslist)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setcountryCode(res.data);
                } else {
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401) {
                    localStorage.clear();
                    history.push("/login");
                    window.location.reload();
                }
            });
    }

    useEffect(() => {
        if (video_portfolio_name) {
            setState({
                name: video_portfolio_name,
                email: video_portfolio_email,
                phone_number: video_portfolio_phone,
                country_code_id: video_portfolio_country_code,
            })
            setIsButtonDisable(false)
        }
    }, [])

    const handleChange = (e) => {
        var newValue
        if (e.target.type === "checkbox") {
            const { id, checked } = e.target;
            newValue = checked ? 1 : 0;
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: (newValue ?? "").toString().trimStart()
            }))

        }


    }



    useEffect(() => {
        let checkValues = Object.values(state["name", "email", "phone_number", "country_code_id"]).every(item => item === true);
        if (checkValues == false) setIsButtonDisable(false)
        else setIsButtonDisable(true)

    }, [state["name", "email", "phone_number", "country_code_id"]])



    /* Validation Checking */
    const ValidateContactForm = (e) => {
        e.preventDefault();
        if (contactFormValidation()) {
            contactSubmitClick();
        }
    }

    const contactFormValidation = () => {
        let nameErrors, phoneNumberErrors;
        let formIsValid = true;
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //Name
        if (!state.name) {
            formIsValid = false;
            nameErrors = "Name cannot be empty";
            setNameErrors(nameErrors);
        } else {
            setNameErrors('');
        }

        //Email

        if (!state.email) {
            formIsValid = false;
            setEmailErrors("Email can not be empty");
        } else if (!emailRegex.test(state.email)) {
            formIsValid = false;
            setEmailErrors('Invalid email address');
        } else {
            setEmailErrors('');
        }

        //Country Code
        if (!state.country_code_id) {
            formIsValid = false;
            countryCodeErrors = "Country Code can not be empty";
            setCountryCodeErrors(countryCodeErrors);
        } else {
            setCountryCodeErrors('');
        }



        //Phone Number

        if (!state.phone_number) {
            formIsValid = false;
            phoneNumberErrors = "Phone Number can not be empty";
            setPhoneErrors(phoneNumberErrors);
        } else {
            if (!!state.phone_number) {
                if (state.phone_number.length < 10 || state.phone_number.length > 15) {
                    // console.log(state.phone_number.length);
                    formIsValid = false;
                    setPhoneErrors("Phone no. should be min 10 and max 15 digits");
                } else setPhoneErrors("");

            }
        }


        return formIsValid;
    }

    const contactSubmitClick = () => {
        setIsButtonDisable(true)
        setIsTextFieldDisable(true)
        setLoader(1);
        let params = JSON.stringify({
            name: state.name ? state.name : null,
            email: state.email ? state.email : null,

        })

        GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioConatactEmailOTP, params)
            .then((res) => {
                setIsButtonDisable(false)
                setIsTextFieldDisable(false)
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    history.push({
                        pathname: `/video-portfolio-verify-otp`,
                    });
                    setLoader(0);
                    localStorage.setItem('video_portfolio_email', state.email)
                    localStorage.setItem('video_portfolio_name', state.name)
                    localStorage.setItem('video_portfolio_phone', state.phone_number)
                    localStorage.setItem('video_portfolio_country_code', state.country_code_id)
                } else {
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    setLoader(0);
                }
            })
            .catch((error) => {
                setIsButtonDisable(false)
                setIsTextFieldDisable(false)
                if (error.response.status === 401) {
                    console.log(error);

                }
            });



    }




    const GoBackClick = (e) => {
        e.preventDefault();
        history.goBack()
    }

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return (
        <>
            <body style={{ backgroundColor: "#fff" }}>



                <div className='video_portfolio_sec'>
                    <div className="video_portfolio_inn video_form_ht" style={{ backgroundImage: 'url(' + VideoPortBanner + ')' }}>
                        <div className='container'>
                            <div className='row justify-content-between'>
                                <div className='col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6'>
                                    <div className='video_portfolio_inn_lt'>
                                        <div className='video_portfolio_inn_lt_logo'>
                                            <img src={VideoLogo} alt='' />
                                            <p>ISO/IEC 27001:2013</p>
                                        </div>

                                        <div className='video_portfolio_inn_btm'>
                                            <h3>Welcome</h3>
                                            <p>Greetings, fellow gamers! We are thrilled to welcome you to our game development company, where we turn your gaming <br />dreams into reality.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-sm-12 col-xxl-4 col-xl-4 col-lg-5 col-md-6'>
                                    <div className='video_portfolio_form_sec'>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <h4 className='video_form_hed'>ENTER THE FOLLOWING DETAILS FOR GET THE PORTFOLIO</h4>

                                                <CForm action="" method="post" className="form-horizontal">
                                                    {loader ?
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                                                            style={{ width: '4rem', height: '4rem', }}
                                                            color="danger"
                                                            variant="grow"
                                                            className="loader_z_index"
                                                        />
                                                        </div>
                                                        : ""}
                                                    <div className="video_portfolio_field">
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <div className='book_meeting'>
                                                                    <CInput
                                                                        type="text"
                                                                        placeholder="Your Name*"
                                                                        value={state.name}
                                                                        name="name"
                                                                        id="name"
                                                                        onChange={handleChange}
                                                                        disabled={isTextFieldDisable ? true : false}
                                                                    />
                                                                    <span className='error_book' style={{ color: "red" }}>{nameErrors}</span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <div className='row'>
                                                                    <div className='col-xxl-3 col-xl-3 col-lg-3 pr-0 col-3 col-md-4 col-sm-3'>
                                                                        <div className='book_meeting'>
                                                                            <CSelect
                                                                                custom

                                                                                name="country_code_id"
                                                                                id="country_code_id"
                                                                                style={{ borderRight: 0, borderRadius: 0, color: state.country_code_id ? "#000" : "#aba4a4" }}
                                                                                value={state.country_code_id}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                }}
                                                                                required
                                                                            >
                                                                                {countryCode
                                                                                    .filter((data) => (data.country_code != "" && data.country_code != null))
                                                                                    .map((item, index) => (
                                                                                        <option key={item.id} value={item.country_code}>
                                                                                            +{item.country_code}
                                                                                        </option>
                                                                                    ))}
                                                                            </CSelect>
                                                                            <span className='error_book' style={{ color: "red" }}>{countryCodeErrors}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xxl-9 col-xl-9 col-lg-9 pl-0 col-9 col-md-8 col-sm-9'>
                                                                        <div className='book_meeting'>
                                                                            <CInput
                                                                                type="number"
                                                                                maxLength={10}
                                                                                pattern="[0-9]*"
                                                                                placeholder="Phone Number*"
                                                                                value={state.phone_number}
                                                                                name="phone_number"
                                                                                id="phone_number"
                                                                                onChange={handleChange}
                                                                                disabled={isTextFieldDisable ? true : false}

                                                                            />
                                                                            <span className='error_book' style={{ color: "red" }}>{phoneErrors}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className='book_meeting'>
                                                                    <CInput
                                                                        type="email"
                                                                        placeholder="Mail ID*"
                                                                        value={state.email}
                                                                        name="email"
                                                                        id="email"
                                                                        onChange={handleChange}
                                                                        disabled={isTextFieldDisable ? true : false}
                                                                    />
                                                                    <span className='error_book' style={{ color: "red" }}>{emailErrors}</span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="booking_btns_sec">
                                                            <div className="atten_sec1 text-center">
                                                                <CButton className="cancel" onClick={GoBackClick}
                                                                    style={{ background: isButtonDisable == true ? '#DFDFDF' : '#ABABAB', marginRight: 10 }}
                                                                ><i class="fa-solid fa-chevron-left"></i> Back</CButton>

                                                                <CButton
                                                                    className={` ${(state.name && state.email && state.phone_number) ? 'save opacity_mild' : 'save '}`}
                                                                    onClick={ValidateContactForm}
                                                                    disabled={isButtonDisable ? true : false}
                                                                >Submit</CButton>

                                                            </div>
                                                        </div>

                                                    </div>

                                                </CForm>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>





            </body>

        </>


    )
}





